export function getYears (props){
    const currentYear = new Date().getFullYear();
    const startYear = props?.start || 2000;
    const yearsArray = [];
  
    for (let year = startYear; year <= (props?.end || currentYear); year++) {
        yearsArray.push(year);
    }
  
    return yearsArray.reverse();
}